<ng-template [sbmodal]="'planningIncompleteModal'">
  <sb-custom-modal [templateId]="'planningIncompleteModal'">
    <div slot="body">
      <div class="d-flex justify-content-center">
        <sb-icon
          [animationOptions]="{autoplay: true, loop: false}" class="red"
          icon="errorAnimation" style="font-size: 5rem"></sb-icon>
      </div>
      <div class="mt-4">{{'lang.planning.planningIncompleteModal' | translate}}
      </div>
      <sb-commercial-conflict-list templateId="planningIncompleteModal" type="modal"></sb-commercial-conflict-list>
    </div>
    <div slot="footer">
      <button (click)="submitPlanning(planning)"
              class="btn-primary btn">{{'lang.globals.submitPlanning' | translate}}</button>
    </div>
  </sb-custom-modal>
</ng-template>

<ng-container *sbPageAction>
  <ng-container *ngPermissions="permissionService.Permission.content_share_list">
    <a [sbRouterLink]="util.RoutingID.contentShare" [queryParams]="{planning: planning?.id}" class="btn btn-primary mr-4" target="_blank">
      {{ 'nav.campaigns.contentShare' | translate }}
    </a>
  </ng-container>
  <ng-container *ngPermissions="[permissionService.Permission.planning_submit]">
    <div
      *ngIf="bookingEditorService?.corruptedCommercials?.corruptedData?.length > 0 || bookingEditorService?.corruptedCommercials?.toConsider?.length > 0"
      [autoClose]="true" class="d-inline-block mr-2" ngbDropdown placement="bottom-right">
      <button (click)="bookingEditorService.checkPlanning()" class="btn btn-light-danger pulse pulse-danger"
              ngbDropdownToggle>
        <sb-icon icon="attention"></sb-icon>
        <span class="pulse-ring" style="left: 3px; top: -1px;"></span>
      </button>
      <div ngbDropdownMenu style="width: 350px">
        <div class="d-flex flex-column py-5"
             style="background-size: cover; background: url('/assets/img/dropdown-bg.jpg') center;">
          <h5 class="d-flex flex-center">
            <span class="white">{{'lang.planning.resolveConflicts' | translate}}</span><span
            class="font-weight-bold btn btn-danger btn-sm ml-2">{{bookingEditorService?.corruptedCommercials ? bookingEditorService?.corruptedCommercials.corruptedData.length : ''}}</span>
          </h5>
        </div>
        <sb-commercial-conflict-list></sb-commercial-conflict-list>
      </div>
    </div>
  </ng-container>
  <ng-container *ngPermissions="[permissionService.Permission.planning_submit]">
    <button (click)="submitPlanningModal(planning)" *ngIf="planning?.id && submitted<0"
            [disabled]="bookingEditorService.loading" class="btn btn-warning font-weight-bold">
      <sb-icon icon="planningSubmit"></sb-icon>
      {{'lang.globals.submitPlanning' | translate}}</button>
  </ng-container>
  <ng-container *ngPermissions="[permissionService.Permission.planning_accept]">
    <button (click)="acceptPlanning(planning)" *ngIf="submitted>0 && planning?.id"
            [disabled]="bookingEditorService.loading" class="btn btn-success font-weight-bold">
      <sb-icon icon="checked"></sb-icon>
      {{'lang.globals.accept' | translate}}</button>
  </ng-container>
  <ng-container *ngPermissions="[permissionService.Permission.planning_submit]">
    <button (click)="rejectPlanning(planning)"
            *ngIf="submitted>0 && planning?.id"
            [disabled]="bookingEditorService.loading" class="btn btn-danger font-weight-bold ml-3">
      <sb-icon icon="cancel"></sb-icon>
      {{'lang.globals.reject' | translate}}</button>
  </ng-container>
</ng-container>

<sb-booking-editor-wrapper [submitted]="submitted"
                           [bookingTitle]="showBookingTitle ? ('lang.globals.planningName' | translate: {name: planning?.name}) : ('lang.globals.currentPlan' | translate)"
                           [planningData]="planning"></sb-booking-editor-wrapper>
